import React from 'react'
import CtaButton from '../buttons/cta-button'
import NormalText from '../texts/normal-text'
import Icon from '../icons/icon'
import HeadingAlpha from '../headings/heading-alpha'
import HeadingDelta from '../headings/heading-delta'
import { Link } from 'react-router-dom'
import logo from '../../styles/images/logo-white.svg'

const Landing = props => (
  <div className='inner-wrapper'>
    <div className='logo'>
      <Link to='/explore'>
        <img src={logo} alt='Chairbids Logo' />
      </Link>
    </div>
    <HeadingAlpha>Welcome!</HeadingAlpha>
    <HeadingDelta thin>
      Chairbids improves lives by mobilizing the caring power of communities
    </HeadingDelta>
    <div className='prominent-icon'>
      <Icon name='saved2' />
    </div>
    <NormalText>
      Search for charities, events and fundraisings near you.
    </NormalText>
    <div className='top-space bottom-space'>
      <Link to='/explore' className='single-link'>
        <CtaButton text='Start Exploring' iconName='goto' />
      </Link>
    </div>
    <NormalText>
      Don't have an account yet?
      <Link to='/register' className='single-link'>
        Sign up
      </Link>
    </NormalText>
    <NormalText>
      Already registered?
      <Link to='/login' className='single-link'>
        Sign in
      </Link>
    </NormalText>
  </div>
)

export default Landing



// WEBPACK FOOTER //
// ./src/ui/views/landing.js